module.exports = __webpack_public_path__ + "img/Postmodernisme_Litteraturen12.5d9d57ee.jpg";